// Shown when someone visits the frontend directly (no ?host= param from
// Shopify admin). Common scenarios:
//   - Developer hits http://localhost:5173 directly in a browser during dev.
//   - Someone pastes the app URL into their address bar outside of admin.
//   - The app URL is indexed by a search engine (shouldn't happen, but).
//
// We don't try to silently redirect to /auth/install — that's a decision
// the merchant should make intentionally (and may require OAuth params
// we don't have).

import { Page, Card, Text, BlockStack } from "@shopify/polaris";

export function NotEmbeddedFallback() {
  return (
    <Page title="Datacrow">
      <Card>
        <BlockStack gap="200">
          <Text as="h2" variant="headingMd">
            Open this app from Shopify admin
          </Text>
          <Text as="p">
            Datacrow runs inside your Shopify admin. To use it, open your
            Shopify admin and go to Apps → Datacrow.
          </Text>
          <Text as="p" tone="subdued">
            Not installed yet? Install Datacrow from the Shopify App Store.
          </Text>
        </BlockStack>
      </Card>
    </Page>
  );
}
